import {
  UPDATE_ORDER_TYPE,
  UPDATE_BUSINESS_TYPE,
  UPDATE_CURRENT_BUS,
  UPDATE_BUS_LIST,
  UPDATE_SZHK_TYPE,
  UPDATE_START_TIME,
  UPDATE_END_TIME,
  UPDATE_ORDER_DAY,
  UPDATE_ORDER_RANGE,
  UPDATE_CURRENT_BUS_INFO,
  UPDATE_BUS_BILL_NUM,
  UPDATE_BUS_BILL,
  UPDATE_OPEN_CITY_LIST,
  UPDATE_OPEN_CITY_LIST_FORMAT,
  UPDATE_RECENT_PRICE,
  UPDATE_TOTAL_PRICE,
  RESET_SELECTED_BUS,
  UPDATE_BUS_LIST_ITEM_PRICE
} from '../mutation-types'
import superagent from 'superagent'
import { RequestControl, RequestCommonResponse } from '../actions'

const state = {
  type: window.localStorage.getItem('order_type') || 'business', // 订单类型 business（商务用车）| szhk （深港互通）
  business_type: window.localStorage.getItem('business_type') || 'round', // 商务用车类型
  szhk_type: window.localStorage.getItem('szhk_type') || 'round', // 深港互通类型
  start_time: window.localStorage.getItem('start_time') ? JSON.parse(window.localStorage.getItem('start_time')) : null, // 出发时间
  end_time: window.localStorage.getItem('end_time') ? JSON.parse(window.localStorage.getItem('end_time')) : null, // 结束时间
  day: window.localStorage.getItem('day') || '', // 包天时间
  range: window.localStorage.getItem('range'), // 行程范围
  bus_list: [],
  current_bus: window.localStorage.getItem('current_bus') ? JSON.parse(window.localStorage.getItem('current_bus')) : {},
  current_bus_info: window.localStorage.getItem('current_bus') ? JSON.parse(window.localStorage.getItem('current_bus_info')) : {},
  bus_bill: [],
  open_city_list: [],
  open_city_list_format: [],
  recent_price: window.localStorage.getItem('recent_price') || null,
  total_price: window.localStorage.getItem('total_price') || null,
  fee_config: {
    '0001': '司机餐饮费',
    '0002': '司机住宿费',
    '0003': '发票',
    '0004': '路桥费',
    '0005': '车辆使用费',
    '0006': '燃油费',
    '0007': '司机服务费',
    '0008': '停车费'
  }
}

const mutations = {
  [UPDATE_ORDER_TYPE] (state, type) {
    state.type = type
    window.localStorage.setItem('order_type', type)
  },
  [UPDATE_CURRENT_BUS] (state, data) {
    state.current_bus = data
    window.localStorage.setItem('current_bus', JSON.stringify(data))
  },
  [UPDATE_BUS_LIST] (state, data) {
    state.bus_list = data
    window.localStorage.setItem('bus_list', JSON.stringify(data))
  },
  [UPDATE_BUS_LIST_ITEM_PRICE] (state, {id, price}) {
    for (var i = 0, len = state.bus_list.length; i < len; i++) {
      if (state.bus_list[i].car_type_id === id) {
        state.bus_list[i].price = price
        break
      }
    }
  },
  [UPDATE_CURRENT_BUS_INFO] (state, data) {
    data = data || {}
    data.contain_fee = ['车辆使用费', '司机服务费', '燃油费', '发票', '路桥费']
    data.uncontain_fee = ['司机餐饮费', '司机住宿费', '停车费']
    state.current_bus_info = data
    window.localStorage.setItem('current_bus_info', JSON.stringify(data))
  },
  [UPDATE_BUSINESS_TYPE] (state, type) {
    state.business_type = type
    window.localStorage.setItem('business_type', type)
  },
  [UPDATE_SZHK_TYPE] (state, type) {
    state.szhk_type = type
    window.localStorage.setItem('szhk_type', type)
  },
  [UPDATE_START_TIME] (state, time) {
    state.start_time = time
    window.localStorage.setItem('start_time', JSON.stringify(time))
  },
  [UPDATE_END_TIME] (state, time) {
    state.end_time = time
    window.localStorage.setItem('end_time', JSON.stringify(time))
  },
  [UPDATE_ORDER_DAY] (state, day_num) {
    state.day = day_num
    window.localStorage.setItem('day', day_num)
  },
  [UPDATE_ORDER_RANGE] (state, range) {
    state.range = range
    window.localStorage.setItem('range', range)
  },
  [UPDATE_BUS_BILL_NUM] (state, { index, type }) {
    if (type === 'add') {
      if (state.bus_bill[index].bus_num < 9) {
        state.bus_bill[index].bus_num++
      }
    } else {
      if (state.bus_bill[index].bus_num > 1) {
        state.bus_bill[index].bus_num--
      } else {
        state.bus_bill.splice(index, 1)
      }
    }
  },
  [UPDATE_BUS_BILL] (state, bus) {
    state.bus_bill.push(bus)
  },
  [UPDATE_OPEN_CITY_LIST] (state, list) {
    state.open_city_list = list
  },
  [UPDATE_OPEN_CITY_LIST_FORMAT] (state, list) {
    state.open_city_list_format = list
  },
  [UPDATE_RECENT_PRICE] (state, price) {
    state.recent_price = price
    window.localStorage.setItem('recent_price', price)
  },
  [UPDATE_TOTAL_PRICE] (state, price) {
    state.total_price = price
    window.localStorage.setItem('total_price', price)
  },
  [RESET_SELECTED_BUS] (state) {
    state.bus_list.splice(0, state.bus_list.length)
    state.bus_bill.splice(0, state.bus_bill.length)
    state.current_bus = {}
    state.current_bus_info = {}
    state.recent_price = null
    window.localStorage.setItem('recent_price', null)
    state.total_price = null
    window.localStorage.setItem('total_price', null)
  }
}

const actions = {
  setCurrentBus ({ commit, state }, index) {
    var _current_bus = state.bus_list[index]
    commit('UPDATE_CURRENT_BUS', _current_bus)
    commit('UPDATE_CURRENT_BUS_INFO', {
      total_price: _current_bus.car_price,
      pricing_type: _current_bus.car_price
    })
  },
  setOrderType ({ commit }, type) {
    commit('UPDATE_ORDER_TYPE', type)
  },
  setBusinessType ({ commit }, type) {
    commit('UPDATE_BUSINESS_TYPE', type)
  },
  setSelectedBusList ({ commit, state }) {
    var selected_list = JSON.parse(window.localStorage.getItem('bus_selected_list')) || []
    for (var i = 0; i < selected_list.length; i++) {
      for (var t = 0; t < state.bus_list.length; t++) {
        if (state.bus_list[t].car_type_id === selected_list[i].car_type_id) {
          state.bus_list[t].bus_num = selected_list[i].bus_num
          var _param = {
            car_type_id: state.bus_list[t].car_type_id,
            car_type_name: state.bus_list[t].car_type_name,
            seat_num: state.bus_list[t].seat_num,
            bus_num: selected_list[i].bus_num,
            price: state.bus_list[t].car_price,
            baggage_num: state.bus_list[t].baggage_num
          }
          if (state.bus_list[t].pricing_type === 1) {
            _param.price = state.current_bus_info.total_price
          }
          commit('UPDATE_BUS_BILL', _param)
        }
      }
    }
  },
  setSZHKType ({ commit }, type) {
    commit('UPDATE_SZHK_TYPE', type)
  },
  setStartDate ({ commit }, date) {
    commit('UPDATE_START_TIME', date)
  },
  setEndDate ({ commit }, date) {
    commit('UPDATE_END_TIME', date)
  },
  // 设置包天天数
  setOrderDay ({ commit }, day_num) {
    commit('UPDATE_ORDER_DAY', day_num)
  },
  // 设置包天范围
  setOrderDayRange ({ commit }, range) {
    commit('UPDATE_ORDER_RANGE', range)
  },
  // 加一辆车
  addOneBus ({ commit, state }, id) {
    var _find = false
    id = id || state.current_bus.car_type_id
    for (var i = 0, len = state.bus_bill.length; i < len; i++) {
      if (state.bus_bill[i].car_type_id === id) {
        _find = true
        commit('UPDATE_BUS_BILL_NUM', {
          index: i,
          type: 'add'
        })
        break
      }
    }
    if (!_find) {
      var _param = {
        car_type_id: state.current_bus.car_type_id,
        car_type_name: state.current_bus.car_type_name,
        seat_num: state.current_bus.seat_num,
        bus_num: 1,
        price: state.current_bus.car_price,
        baggage_num: state.current_bus.baggage_num
      }
      if (state.current_bus_info.pricing_type === 1) {
        _param.price = state.current_bus_info.total_price
      }
      commit('UPDATE_BUS_BILL', _param)
    }
  },
  // 减一辆车
  reduceOneBus ({ commit, state }, id) {
    id = id || state.current_bus.car_type_id
    for (var i = 0, len = state.bus_bill.length; i < len; i++) {
      if (state.bus_bill[i].car_type_id === id) {
        commit('UPDATE_BUS_BILL_NUM', {
          index: i,
          type: 'reduce'
        })
        break
      }
    }
  },
  // 获取车辆图片
  getCarPhoto ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/charter/mine/get_car_type_info')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          reject(_res)
        }
      })
    })
  },
  setRecentPrice ({ commit, state }, price) {
    commit('UPDATE_RECENT_PRICE', price)
  },
  setTotalPrice ({ commit, state }, price) {
    commit('UPDATE_TOTAL_PRICE', price)
  },
  // 取消订单原因
  sendCancleReason ({ commit, state, rootState }, params) {
    // params eg. {order_id: orderId, label_id: _self.labelId}
    return new Promise(function (resolve, reject) {
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/charter/mine/cancel_order_reason')
      .type('form')
      .send(params)
      .end(function (err, res) {
        if (err) {
          throw err
        }
        const _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  }
}

export default {
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js